// ===========================
//  Zifit Landing – React code
//  All components + PrivacyPolicyPage
// ===========================

// ────────────────────────────
// src/pages/PrivacyPolicyPage.jsx
// ────────────────────────────
import React from "react";

export default function PrivacyPolicyPage() {
  const SUPPORT_EMAIL =
    process.env.REACT_APP_SUPPORT_EMAIL || "support@zifit.io";

  return (
    <div className="container mx-auto max-w-3xl py-20 px-4 prose">
      <h1>Política de Privacidad</h1>
      <p>
        <strong>Última actualización:</strong> 1 de Enero de 2025
      </p>
      <p>
        Esta Política de Privacidad describe cómo Zifit (“nosotros”) maneja y
        protege la información personal que recopilamos sobre nuestros
        usuarios.
      </p>
      <h2>Información que recopilamos</h2>
      <p>
        Recopilamos información personal que el usuario nos proporciona
        directamente, como el nombre, correo electrónico y cualquier otro dato
        que decida compartir.
      </p>
      <h2>Uso de la información</h2>
      <p>
        Utilizamos la información para proporcionar, mantener y mejorar
        nuestros servicios, comunicarnos con los usuarios y personalizar su
        experiencia.
      </p>
      <h2>Compartir la información</h2>
      <p>
        No vendemos ni alquilamos información personal a terceros. Podemos
        compartirla con proveedores de servicios que nos ayudan a operar la
        plataforma siempre bajo acuerdos de confidencialidad.
      </p>
      <h2>Seguridad</h2>
      <p>
        Implementamos medidas razonables para proteger la información personal
        frente a accesos no autorizados.
      </p>
      <h2>Cambios a esta política</h2>
      <p>
        Podemos actualizar esta Política ocasionalmente. Cualquier cambio será
        efectivo al publicar la nueva versión en esta página.
      </p>
      <h2>Contacto</h2>
      <p>
        Si tienes dudas sobre esta Política de Privacidad, escríbenos a
        <strong> {SUPPORT_EMAIL}</strong>.
      </p>
    </div>
  );
}
